import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';

const SettingsEmptyContent: React.FC<{ title?: string | React.ReactNode; desction?: string | React.ReactNode }> = ({
  title,
  desction,
}) => {
  return (
    <div className={styles.content}>
      <Image src="/images/report/empty-icon.webp" alt="" width={200} height={170} />

      {typeof title === 'string' ? (
        <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
      ) : (
        <div className={styles.title}>{title}</div>
      )}

      {typeof desction === 'string' ? (
        <div className={styles.desction} dangerouslySetInnerHTML={{ __html: desction }} />
      ) : (
        <div className={styles.desction}>{desction}</div>
      )}
    </div>
  );
};

export default SettingsEmptyContent;
